import { render } from "./BuyOnWebModal.vue?vue&type=template&id=0a6007c7"
import script from "./BuyOnWebModal.vue?vue&type=script&lang=js"
export * from "./BuyOnWebModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/lie/repo/blisspot_vue_app/nuron-vuejs/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__